import React from 'react';
import classnames from 'classnames';
import { H5 } from 'scy/text';
import { container, text, divider } from './styles.mod.scss';

export default function TextHR({ className, children }) {
  return (
    <div className={classnames(container, className)}>
      <H5 tag="div" className={text}>
        {children}
      </H5>
      <div className={divider} />
    </div>
  );
}
